import { ContactEditorFormKeys } from '../../../../configs'

type ErorrRespomse = {
  field?: string
  message: string
}

const generalFormField: Record<string, string> = {
  email: 'email',
  firstName: 'firstName',
  lastName: 'lastName',
}

const commonFormField: Record<string, string> = {
  countryOfBusiness: 'countryOfBusiness',
  mobilePhoneNumber: 'mobilePhoneNumber',
  mobilePhoneCode: 'mobilePhoneCode',
  isNeverCall: 'isNeverCall',
  isNeverEmail: 'isNeverEmail',
  emailPixels: 'emailPixels',
  preferredLanguage: 'preferredLanguage',
  salutation: 'salutation',
  seniority: 'seniority',
  status: 'status',
  workPhoneNumber: 'workPhoneNumber',
  workPhoneCode: 'workPhoneCode',
  modifiedValues: 'modifiedValues',
  primaryJobRole: 'primaryJobRole',
}

const hpRolesFormField: Record<string, string> = {
  hpRoles: 'hpRoles',
}

export function prepareValidationResponse(response: ErorrRespomse[]) {
  return response
    .map((el) => {
      if (el.field) {
        if (generalFormField[el.field]) {
          return {
            key: ContactEditorFormKeys.general,
            field: generalFormField[el.field],
            validationMessage: el.message,
          }
        }
        if (commonFormField[el.field]) {
          return {
            key: ContactEditorFormKeys.common,
            field: commonFormField[el.field],
            validationMessage: el.message,
          }
        }
        if (hpRolesFormField[el.field]) {
          return {
            key: ContactEditorFormKeys.hpRoles,
            field: hpRolesFormField[el.field],
            validationMessage: el.message,
          }
        }
      }
      return null
    })
    .filter(Boolean)
}
